module.exports = __webpack_public_path__ + "static/media/bg2.55fccd68.jpg";